// Import from NPM
// -------------------------------------
import React from "react";
import { useFeatures } from "flagged";
import { useNavigate } from "react-router-dom";

import { Div } from "@components/Generics.react";
import "@styles/courseLayout.scss";

export default function LogoBlock(props) {
    const { isolated, user, logo, isSim } = props;
    const features = useFeatures();
    const navigate = useNavigate();
    const isPortrait = window.innerWidth < window.innerHeight;
    const enablePortraitNavStyling = features.navbar.enablePortraitNavStyling;

    // ========================= Render Function =================================
    return (
        <Div
            float-left
            rounded={!isPortrait}
            white={(enablePortraitNavStyling && isPortrait) || !isPortrait}
            className="logo-block"
            onClick={() => navigate(isolated ? "#" : "/")}
            style={{
                background: "#ffffff",
                boxShadow: `0 0 15px 1px #000000 inset`,
                position: "relative",
                zIndex: 2,
            }}
        >
            <img
                src={
                    features.tenanting.multiTenanted
                        ? user.branding?.logo ||
                          `/assets/images/configurable/logo${
                              features.darkMode ? "-inverted" : ""
                          }.png`
                        : logo ||
                          `/assets/images/configurable/logo${
                              features.darkMode ? "-inverted" : ""
                          }.png`
                }
                alt="Brand Logo"
                className="logo"
            />
        </Div>
    );
}
